import { notification } from 'antd';
import React, { useEffect, useState } from 'react';
import { blueArrow, locationGrey } from '../../assets/images';
import { handleAppError } from '../handlers';

const AddAddressModal = ({ newAddress, employeeID, changeHandler, addAddressHandler, addLine1 }) => {

  const [state, setState] = useState({
    loading: true, newAddress: newAddress, employeeID: employeeID,
    benefitType: 'ahc', location: '', address: '', zipcode: newAddress?.zip_code, addressTag: null, addressLine1: null
  })

  const previewAddress = `${state.newAddress?.line2 ? state.newAddress?.line2 + ',' : ''} ${state.newAddress?.city}, ${state.newAddress?.state}, ${state.newAddress?.country}`

  const [activeButton, setActiveButton] = useState('Home');

  const handleClick = (button) => {
    setActiveButton(button);
  };

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const addressHandler = (e) => {
    setSubState({ addressLine1: e.target.value })
    addLine1(e.target.value)
  }

  const zipHandler = (name, value) => {
    setSubState({ zipcode: value })
  }

  const tagHandler = (e) => {
    setSubState({ addressTag: e.target.value })
  }

  const checkZipcode = (name, value) => {
    let validation = true
    if (true) {
      if (value.length === 0) {
        notification['error']({
          message: 'Zip Code should not be empty',
          description: "please enter pin code"
        })
        validation = false
        setSubState({ disableBooking: true });
      }
      else if (!value.match(/^[1-9][0-9]{5}$/)) {
        notification['error']({
          message: 'Pincode should be 6 digits and starts with [1-9]',
          description: "please enter valid pincode"
        })
        validation = false;
        setSubState({ disableBooking: true });
      }
    }
    if (validation && value !== state.employeeMobileNumber) {
      zipHandler(name, value)
    }
  }

  const addnewAddress = (params) => {

    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/addresses?company_id=" + sessionStorage.getItem('company_id') 
      window.axios.post(url, params)
        .then(function (response) {
          setSubState({ loading: false })
        })
        .catch(function (error) {
          setSubState({ loading: false })
          handleAppError(error)
        })
    }
  }

  const addNewAddressHandler = () => {

    const params = {
      address: {
        line1: state.addressLine1,
        line2: state.newAddress.line2,
        city: state.newAddress.city,
        state: state.newAddress.state,
        country: state.newAddress.country,
        latitude: state.newAddress.latitude,
        longitude: state.newAddress.longitude,
        address_tag: state.addressTag ?? activeButton,
        zip_code: state.zipcode
      }
    }

    addnewAddress(params);
    addAddressHandler();
  }

  return (
    <div className=' pt-6 flex-col flex justify-between h-full' style={{ background: '#F5F7F9' }}>
      <div className=''>
        <div className='flex p-4 border border-gray-200 bg-white mb-3'>
          <img src={locationGrey} className='h-7 mr-1 mt-1' />
          <div>
            <div className='font-semibold text-base text-gray-800 ml-2'>{state.newAddress?.city}</div>
            <div className='ml-2'>{previewAddress}</div>
            <button className={`text-blue-600 text-sm font-medium cursor-pointer ml-2`} onClick={(e) => changeHandler(e)}>Change<img src={blueArrow} className='inline-block ml-1' /></button>
          </div>
        </div>
        <div className='bg-white px-6 pt-1 pb-2 border border-gray-200'>
          <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-3 mb-3'>HOUSE/FLAT NO</div>
          <div className='bg-gray-100'>
            <input type='text' name='address' value={state.addressLine1} placeholder='Enter House/Flat No'
              onChange={(e) => {
                addressHandler(e)
              }}
              className={`border address border-gray-200 bg-gray-100 p-3 rounded-md w-full placeholder-gray-300 text-base font-semibold leading-4 text-gray-700`} />
          </div>
          <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>PINCODE</div>
          <input type='number' name='zip_code' value={state.zipcode} placeholder='Enter Pincode'
            onChange={(e) => {
              let { name, value } = e.target
              zipHandler(name, value)
            }}
            onBlur={(e) => {
              let { name, value } = e.target
              checkZipcode(name, value)
            }}
            className={`border address border-gray-200 bg-gray-100 p-3 rounded-md w-full placeholder-gray-300 text-base font-semibold leading-4 text-gray-700`} />
          <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500 mt-6 mb-3'>SAVE AS</div>
          <div className='flex mb-2'>
            <button
              type='submit'
              onClick={() => handleClick('Home')}
              className={`block rounded-3xl px-3 py-2 mr-2 border text-base font-semibold ${activeButton == 'Home' ? 'bg-blue-600 text-white' : ' bg-white text-gray-600 border-gray-200 hover:bg-blue-600 hover:text-white'}`}
            >
              Home
            </button>
            <button
              type='submit'
              onClick={() => handleClick('Office')}
              className={`block rounded-3xl px-3 py-2 mr-2 border text-base font-semibold ${activeButton == 'Office' ? 'bg-blue-600 text-white' : ' bg-white text-gray-600 border-gray-200 hover:bg-blue-600 hover:text-white'}`}
            >
              Office
            </button>
            <button
              type='submit'
              onClick={() => handleClick('Other')}
              className={`block rounded-3xl px-3 py-2 mr-2 border text-base font-semibold ${activeButton == 'Other' ? 'bg-blue-600 text-white' : ' bg-white text-gray-600 border-gray-200 hover:bg-blue-600 hover:text-white'}`}
            >
              Other
            </button>
          </div>
          {activeButton == 'Other' && <input type='text' name='address_tag' value={state.addressTag} placeholder='Eg Hostel/Neighbour House'
            onChange={(e) => {
              tagHandler(e)
            }}
            className={`border address border-gray-200 bg-gray-100 p-3 rounded-md w-full placeholder-gray-300 text-base font-semibold leading-4 text-gray-700 mb-2`} />}
        </div>
      </div>
      <div className='bg-white h-20 flex justify-center' style={{ boxShadow: '0px -2px 10px #E5E8F0' }}>
        <button
          disabled={state.zipcode == null || state.addressLine1 == null}
          onClick={addNewAddressHandler}
          className={`block rounded border w-full p-2 mx-3 my-4 border-transparent text-base font-semibold text-white ${(state.zipcode == null || state.addressLine1 == null) ? ' bg-gray-300 cursor-not-allowed' : 'bg-blue-500'}`}
        >
          Save address & continue
        </button>
      </div>
    </div>
  )

}

export default AddAddressModal;